



import { useEffect, useState } from "react";
import {
  getExpenseCategoriesApi,
  listOfficeExpensesApi,
  deleteOfficeExpenseApi,
} from "../../app/api";
import { useNavigate } from "react-router-dom";
import EditExpenseModal from "./EditExpenseModal";
import { createPortal } from "react-dom";
import {
  PlusCircle,
  Search,
  Filter,
  Calendar,
  IndianRupee,
  Tag,
  User,
  ExternalLink,
  Trash2,
  Edit3,
  RotateCcw,
  LayoutList,
  ChevronRight,
  AlertCircle,
  X,
  CreditCard,
  FileText
} from "lucide-react";
const FILE_BASE_URL = "https://demouptask.visiontrek.io";
export default function ExpenseList() {
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editExpense, setEditExpense] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
 
  const [filters, setFilters] = useState({
    category_id: "",
    from_date: "",
    to_date: "",
  });
 
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
  });
 
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };
 
  useEffect(() => {
    loadCategories();
    loadExpenses();
  }, []);
 
  const loadCategories = async () => {
    const res = await getExpenseCategoriesApi();
    if (res.success) setCategories(res.data || []);
  };
 
  const loadExpenses = async () => {
    setIsLoading(true);
    const res = await listOfficeExpensesApi();
    if (res.success) setExpenses(res.data || []);
    setIsLoading(false);
  };
 
  const handleDeleteExpense = async () => {
    const id = deleteModal.id;
    setDeleteModal({ show: false, id: null });
    const res = await deleteOfficeExpenseApi(id);
    if (res.success) {
      loadExpenses();
    } else {
      alert("Delete failed");
    }
  };
 
  const handleReset = () => {
    setFilters({ category_id: "", from_date: "", to_date: "" });
  };
 
  const filteredExpenses = expenses.filter((exp) => {
    const catMatch = filters.category_id ? exp.expense_category_id == filters.category_id : true;
    const date = new Date(exp.purchase_date);
    const from = filters.from_date ? new Date(filters.from_date) : null;
    const to = filters.to_date ? new Date(filters.to_date) : null;
    return catMatch && (!from || date >= from) && (!to || date <= to);
  });
 
  return (
    <div className="max-w-8xl mx-auto md:mt-20 mb-20 ">
    <div className="
      relative overflow-hidden
      rounded-[20px] p-8 md:p-12
      bg-gradient-to-br from-[#1e174a] to-[#0f0c29]/95
      backdrop-blur-2xl text-white
      border border-white/10
      shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
    ">
      {/* HEADER SECTION */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-12 px-2 text-white">
        <div className="flex items-center gap-4">
          <div className="p-3.5 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-xl shadow-blue-500/20">
            <LayoutList className="w-8 h-8 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-semibold text-white whitespace-nowrap">Expense List</h1>
            <p className="text-white/60 text-sm">Verify and manage the team overall expenditures</p>
          </div>
        </div>
 
        <div className="flex items-center gap-3 w-full md:w-auto">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className={`flex-1 md:flex-none whitespace-nowrap flex items-center justify-center gap-2 px-1.5 py-3.5 md:px-6 md:py-3.5 rounded-2xl transition-all duration-300 font-bold text-xs uppercase tracking-widest ${showFilters ? 'bg-white text-black' : 'bg-white/5 border border-white/10 text-white'}`}
          >
            <Filter className="w-4 h-4" />
            {showFilters ? 'Hide Toolbar' : 'Filters'}
          </button>
         
          <button
            onClick={() => navigate("/expenses/add")}
            className="flex-1 md:flex-none whitespace-nowrap flex items-center justify-center gap-2 px-2 py-3.5 md:px-6 md:py-3.5 rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-500 hover:to-indigo-600 transition-all shadow-xl shadow-blue-500/20 font-bold text-xs uppercase tracking-widest text-white"
          >
            <PlusCircle className="w-4 h-4" />
            NEW RECORD
          </button>
        </div>
      </div>
 
      {/* FILTER DRAWER */}
      {showFilters && (
        <div className="mb-4 p-3 rounded-lg  bg-white/5 border border-white/10 backdrop-blur-3xl animate-in slide-in-from-top-4 duration-500 mt-[-24px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="space-y-2 mt-[-4px]">
              <label className="text-[10px] font-black uppercase tracking-widest text-white/40 ml-1">Search Category</label>
              <select
                value={filters.category_id}
                onChange={(e) => setFilters({ ...filters, category_id: e.target.value })}
                className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-1.5 text-sm text-white outline-none focus:border-blue-500/50 appearance-none cursor-pointer"
              >
                <option value="" className="bg-[#1b1040]">All Categories</option>
                {categories.map((c) => (
                  <option key={c.id} value={c.id} className="bg-[#1b1040]">{c.name}</option>
                ))}
              </select>
            </div>
 
            <div className="space-y-2 mt-[-4px]">
              <label className="text-[10px] font-black uppercase tracking-widest text-white/40 ml-1">From Date</label>
              <input
                type="date"
                value={filters.from_date}
                onChange={(e) => setFilters({ ...filters, from_date: e.target.value })}
                className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-1.5 text-sm text-white outline-none focus:border-blue-500/50 appearance-none cursor-pointer"
              />
            </div>
 
            <div className="space-y-2 mt-[-4px]">
              <label className="text-[10px] font-black uppercase tracking-widest text-white/40 ml-1">To Date</label>
              <input
                type="date"
                value={filters.to_date}
                onChange={(e) => setFilters({ ...filters, to_date: e.target.value })}
                className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-1.5 text-sm text-white outline-none focus:border-blue-500/50 appearance-none cursor-pointer"
              />
            </div>
 
            <div className="flex items-end">
              <button
                onClick={handleReset}
                className="w-full flex items-center justify-center gap-2 px-6 py-2.5 rounded-lg bg-white/5 border border-white/10 text-white/60 hover:text-red-400 hover:bg-red-500/10 hover:border-red-500/20 transition-all font-black text-[10px] uppercase tracking-widest"
              >
                <RotateCcw className="w-3.5 h-3.5" />
                Reset Baseline
              </button>
            </div>
          </div>
        </div>
      )}
 
      {/* DATA TABLE - DESKTOP */}
      {/* <div className="hidden lg:block overflow-hidden rounded-[32px] bg-white/5 border border-white/10 backdrop-blur-2xl shadow-2xl">
        <table className="w-full text-left">
          <thead> */}

<div className="hidden lg:block max-h-[420px] overflow-y-auto no-scrollbar rounded-lg bg-white/5 border border-white/10 backdrop-blur-2xl shadow-2xl p-2">
        <table className="w-full text-left ">
          <thead className="">
            
            <tr className="bg-white/[0.03] border-b border-white/10">
              <th className="p-4 text-[10px] font-black uppercase tracking-widest text-white/40">Classification</th>
              <th className="p-4 text-[10px] font-black uppercase tracking-widest text-white/40">Amount</th>
              <th className="p-4 text-[10px] font-black uppercase tracking-widest text-white/40">Description</th>
              <th className="p-4 text-[10px] font-black uppercase tracking-widest text-white/40">Timeline</th>
              <th className="p-4 text-[10px] font-black uppercase tracking-widest text-white/40">Invoice</th>
              <th className="p-4 text-[10px] font-black uppercase tracking-widest text-white/40">Initiator</th>
              <th className="p-4 text-[10px] font-black uppercase tracking-widest text-white/40 text-center">Manage</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {isLoading ? (
              <tr><td colSpan="7" className="p-20 text-center"><div className="w-8 h-8 border-2 border-blue-500 border-t-white rounded-full animate-spin mx-auto" /></td></tr>
            ) : filteredExpenses.length === 0 ? (
              <tr><td colSpan="7" className="p-20 text-center opacity-20 font-black uppercase tracking-widest">No matching logs found</td></tr>
            ) : (
              filteredExpenses.map((exp) => (
                <tr key={exp.id} className="group hover:bg-white/[0.04] transition-all duration-300 whitespace-nowrap">
                  <td className="p-3">
                    <div className="flex items-center gap-3">
                      {/* <div className="w-7 h-7 rounded-xl bg-purple-500/10 border border-purple-500/20 flex items-center justify-center">
                        <Tag className="w-2 h-2 text-purple-400" />
                      </div> */}
                      <span className="text-sm font-semibold text-white/70">{exp.category_name}</span>
                    </div>
                  </td>
                  <td className="p-3">
                    <div className="flex items-center  text-blue-400">
                      <IndianRupee className="w-4 h-4" />
                      <span className="text-md font-semibold ">{Number(exp.amount).toLocaleString()}</span>
                    </div>
                  </td>
                  <td className="p-3">
                    <p className="text-xs font-medium text-white/60 max-w-[200px] truncate">{exp.purpose || "N/A"}</p>
                  </td>
                  <td className="p-3">
                    <div className="flex items-center gap-2 text-xs font-bold text-white/40">
                      <Calendar className="w-3.5 h-3.5" />
                      {formatDate(exp.purchase_date)}
                    </div>
                  </td>
                  {/* <td className="p-3">
                    {exp.bill_path ? (
                      <a href={exp.bill_path} target="_blank" className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-emerald-400 bg-emerald-400/10 px-3 py-1.5 rounded-full hover:bg-emerald-400/20 transition-all">
                        <FileText className="w-3 h-3" />
                        View Bill
                      </a>
                    ) : (
                      <span className="text-[10px] font-bold text-white/10 uppercase italic">Missing Bill</span>
                    )}
                  </td> */}

<td className="px-3">
                    {exp.bill_path ? (
                      <a
                        href={`${FILE_BASE_URL}${exp.bill_path}`}
                        target="_blank"
                        className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-emerald-400 bg-emerald-400/10 px-3 py-1.5 rounded-full hover:bg-emerald-400/20 transition-all"
                      >
                         <FileText className="w-3 h-3" />
                        View Bill
                      </a>
                    ) : (

                      <span className="text-[10px] font-bold text-white/10 uppercase italic">Missing Bill</span>

                      // "-"
                    )}
                  </td>
                  <td className="p-3">
                    <div className="flex items-center gap-2">
                       {/* <div className="w-7 h-7 rounded-full bg-white/5 flex items-center justify-center border border-white/10">
                        <User className="w-3 h-3 text-white/30" />
                       </div> */}
                       <span className="text-xs font-bold text-white/70">{exp.created_by_name}</span>
                    </div>
                  </td>
                  <td className="p-3">
                    <div className="flex justify-center gap-2">
                      <button onClick={() => setEditExpense(exp)} className="p-2.5 rounded-xl bg-blue-500/10 border border-blue-500/20 text-blue-400 hover:bg-blue-600 hover:text-white transition-all">
                        <Edit3 className="w-4 h-4" />
                      </button>
                      <button onClick={() => setDeleteModal({ show: true, id: exp.id })} className="p-2.5 rounded-xl bg-red-500/10 border border-red-500/20 text-red-400 hover:bg-red-600 hover:text-white transition-all">
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
 
      {/* MOBILE LIST */}
      <div className="lg:hidden space-y-4">
        {filteredExpenses.map((exp) => (
          <div key={exp.id} className="bg-white/5 border border-white/10 rounded-[32px] p-4 backdrop-blur-xl shadow-2xl relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/5 blur-3xl group-hover:bg-blue-500/10 transition-all" />
           
            <div className="flex justify-between items-start mb-6">
              <div className="flex items-center gap-3">
                <div className="p-3 rounded-2xl bg-purple-500/20 border border-purple-500/10">
                  <Tag className="w-5 h-5 text-purple-400" />
                </div>
                <div>
                  <h3 className="font-black text-white">{exp.category_name}</h3>
                  <div className="flex items-center gap-1.5 text-xs text-white/30 font-bold">
                    <Calendar className="w-3.5 h-3.5" />
                    {formatDate(exp.purchase_date)}
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-end">
                <div className="flex items-center gap-1 text-xl font-black text-blue-400">
                  <IndianRupee className="w-4 h-4" />
                  {Number(exp.amount)}
                </div>
                <span className="text-[9px] font-black uppercase text-white/20 tracking-tighter">Total Gross</span>
              </div>
            </div>
 
            <div className="p-5 rounded-2xl bg-white/5 border border-white/5 mb-6 space-y-4">
               <div>
                  <label className="text-[9px] font-black uppercase tracking-widest text-white/20 block mb-1">Narration</label>
                  <p className="text-xs font-semibold text-white/70 italic">"{exp.purpose || 'Official procurement'}"</p>
               </div>
               <div className="flex justify-between items-center py-3 border-t border-white/5">
                 <div className="flex items-center gap-2">
                   <div className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center">
                     <User className="w-3 h-3 text-white/50" />
                   </div>
                   <span className="text-xs font-bold text-white/60">{exp.created_by_name}</span>
                 </div>
                 {exp.bill_path && (
                   <a href={exp.bill_path} className="flex items-center gap-1.5 text-[10px] font-black text-emerald-400 uppercase tracking-widest">
                     Invoice <ChevronRight className="w-3 h-3" />
                   </a>
                 )}
               </div>
            </div>
 
            <div className="flex gap-3">
              <button
                onClick={() => setEditExpense(exp)}
                className="flex-1 py-4 rounded-2xl bg-white/5 border border-white/10 text-white font-black text-[10px] uppercase tracking-widest hover:bg-blue-600 hover:border-blue-500 transition-all"
              >
                Refactor
              </button>
              <button
                onClick={() => setDeleteModal({ show: true, id: exp.id })}
                className="flex-1 py-4 rounded-2xl bg-red-500/10 border border-red-500/20 text-red-400 font-black text-[10px] uppercase tracking-widest hover:bg-red-600 hover:text-white transition-all"
              >
                Erase
              </button>
            </div>
          </div>
        ))}
      </div>
 
      {/* DELETE MODAL PORTAL */}
      {deleteModal.show && createPortal(
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
           <div className="absolute inset-0 bg-black/80 backdrop-blur-xl" onClick={() => setDeleteModal({ show: false, id: null })} />
           <div className="relative w-full max-w-sm bg-gradient-to-br from-[#1e174a] to-[#0f0c29] rounded-[40px] p-10 text-center border border-white/20 shadow-2xl animate-scaleIn">
              <div className="w-20 h-20 bg-red-500/20 rounded-[28px] flex items-center justify-center mx-auto mb-6">
                <Trash2 className="w-10 h-10 text-red-500" />
              </div>
              <h3 className="text-2xl font-black text-white mb-2">Confirm Delete</h3>
              <p className="text-sm font-medium text-white/40 mb-8 leading-relaxed"> Are You Want Delete this expense?</p>
              <div className="flex flex-col gap-3">
                <button onClick={handleDeleteExpense} className="w-full py-4 rounded-2xl bg-red-600 text-white font-black text-xs uppercase tracking-widest hover:bg-red-700 transition shadow-xl shadow-red-900/40">
                  Delete RECORD
                </button>
                <button onClick={() => setDeleteModal({ show: false, id: null })} className="w-full py-4 rounded-2xl bg-white/5 border border-white/10 text-white/60 font-black text-xs uppercase tracking-widest">
                  Cancel
                </button>
              </div>
           </div>
        </div>,
        document.body
      )}
 
      {/* EDIT MODAL PORTAL */}
      {editExpense && (
        <EditExpenseModal
          expense={editExpense}
          categories={categories}
          onClose={() => setEditExpense(null)}
          onUpdated={() => {
            setEditExpense(null);
            loadExpenses();
          }}
        />
      )}
    </div>
    </div>
  );
}
 
function Input(props) {
  return (
    <input
      {...props}
      className="bg-white/5 border border-white/10 rounded-2xl px-5 py-3.5 text-sm text-white outline-none transition focus:border-blue-500/50 appearance-none inline-block w-full"
    />
  );
}
 
function Select({ options, placeholder, ...props }) {
  return (
    <div className="relative group">
      <select
        {...props}
        className="bg-white/5 border border-white/10 rounded-2xl px-5 py-3.5 text-sm text-white outline-none transition focus:border-blue-500/50 appearance-none cursor-pointer w-full"
      >
        <option value="" className="bg-[#1b1040]">{placeholder}</option>
        {options.map((o, i) => (
          <option key={i} value={o.value} className="bg-[#1b1040] text-white">
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
 






// import { useEffect, useState } from "react";
// import {
//   getExpenseCategoriesApi,
//   listOfficeExpensesApi,
//   deleteOfficeExpenseApi,
// } from "../../app/api";
// import { useNavigate } from "react-router-dom";
// import EditExpenseModal from "./EditExpenseModal";
// import { createPortal } from "react-dom";

// export default function ExpenseList() {
//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
  
//     const d = new Date(dateString);
//     const day = String(d.getDate()).padStart(2, "0");
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const year = d.getFullYear();
  
//     return `${day}/${month}/${year}`; // change "/" to "-" if you want
//   };
  
  
//   const [editExpense, setEditExpense] = useState(null);
//   const navigate = useNavigate();
//   const FILE_BASE_URL = "";

//   const [expenses, setExpenses] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [filters, setFilters] = useState({
//     category_id: "",
//     from_date: "",
//     to_date: "",
//   });

//   const [deleteModal, setDeleteModal] = useState({
//     show: false,
//     id: null,
//   });

//   useEffect(() => {
//     getExpenseCategoriesApi().then((res) => {
//       if (res.success) setCategories(res.data || []);
//     });

//     loadExpenses();
//   }, []);

//   const loadExpenses = async () => {
//     const res = await listOfficeExpensesApi();
//     if (res.success) setExpenses(res.data || []);
//   };

//   const handleDeleteExpense = async () => {
//     const res = await deleteOfficeExpenseApi(deleteModal.id);
//     if (res.success) {
//       setDeleteModal({ show: false, id: null });
//       loadExpenses();
//     } else {
//       alert("Delete failed");
//     }
//   };

//   const handleReset = () => {
//     setFilters({ category_id: "", from_date: "", to_date: "" });
//   };

//   const filteredExpenses = expenses.filter((exp) => {
//     const catMatch = filters.category_id
//       ? exp.expense_category_id == filters.category_id
//       : true;

//     const date = new Date(exp.purchase_date);
//     const from = filters.from_date ? new Date(filters.from_date) : null;
//     const to = filters.to_date ? new Date(filters.to_date) : null;

//     return catMatch && (!from || date >= from) && (!to || date <= to);
//   });

//   return (
//     <div className="rounded-2xl md:mt-20 p-6 bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f] text-white border border-white/10 shadow-2xl relative">
//       <h3 className="font-bold text-2xl mb-5 ">
//         Office Expense List
//       </h3>

//       {/* FILTERS */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-5">
//         <Select
//           value={filters.category_id}
//           onChange={(e) =>
//             setFilters({ ...filters, category_id: e.target.value })
//           }
//           options={categories.map((c) => ({
//             value: c.id,
//             label: c.name,
//           }))}
//           placeholder="All Categories"
//         />

//         <Input
//           type="date"
//           value={filters.from_date}
         
//           onChange={(e) =>
//             setFilters({ ...filters, from_date: e.target.value })
//           }
         
//         />

//         <Input
//           type="date"
//           value={filters.to_date}
//           onChange={(e) =>
//             setFilters({ ...filters, to_date: e.target.value })
//           }
//         />

//         <button
//           onClick={handleReset}
//           className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 border border-white/20"
//         >
//           Reset
//         </button>
//       </div>

//       {/* ================= DESKTOP TABLE ================= */}
      // <div className="hidden md:block max-h-[420px] overflow-y-auto">
      //   <table className="w-full text-sm border-separate border-spacing-x-3">
      //     <thead className="text-white/70 border-b border-white/10">
//             <tr>
//               <th className="px-3 text-left">Category</th>
//               <th className="px-3 text-left">Amount</th>
//               <th className="px-3 text-left">Purpose</th>
//               <th className="px-3 text-left">Date</th>
//               <th className="px-3 text-left">Bill</th>
//               <th className="px-3 text-left">Created By</th>
//               <th className="px-3 text-left">Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredExpenses.length > 0 ? (
//               filteredExpenses.map((exp) => (
//                 <tr
//                   key={exp.id}
//                   className="border-b border-white/5 hover:bg-white/5"
//                 >
//                   <td className="px-3 py-2">
//                     {exp.category_name}
//                   </td>
//                   <td className="px-3 font-semibold text-blue-300">
//                     ₹ {exp.amount}
//                   </td>
//                   <td className="px-3">
//                     {exp.purpose || "-"}
//                   </td>
//                   <td className="px-3">
            
// {formatDate(exp.purchase_date)}

//                   </td>
                  // <td className="px-3">
                  //   {exp.bill_path ? (
                  //     <a
                  //       href={`${FILE_BASE_URL}${exp.bill_path}`}
                  //       target="_blank"
                  //       className="text-blue-300 underline"
                  //     >
                  //       View
                  //     </a>
                  //   ) : (
                  //     "-"
                  //   )}
                  // </td>
//                   <td className="px-3">
//                     {exp.created_by_name}
//                   </td>
//                   <td className="px-3 flex gap-2">
//   <button
//     onClick={() => setEditExpense(exp)}
//     className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-xs"
//   >
//     Edit
//   </button>
//                     <button
//                       onClick={() =>
//                         setDeleteModal({
//                           show: true,
//                           id: exp.id,
//                         })
//                       }
//                       className="px-3 py-1 rounded-full bg-red-500/20 text-red-300 text-xs"
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan="7"
//                   className="py-6 text-center opacity-60"
//                 >
//                   No expenses found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ================= MOBILE CARDS ================= */}
//       <div className="md:hidden space-y-3">
//         {filteredExpenses.map((exp) => (
//           <div
//             key={exp.id}
//             className="bg-gradient-to-br from-[#2d1c6a] to-[#12082f] border border-white/10 rounded-2xl p-4 shadow-lg"
//           >
//             <div className="flex justify-between items-center mb-2">
//               <p className="font-semibold text-blue-300">
//                 {exp.category_name}
//               </p>
//               <p className="font-bold text-green-300">
//                 ₹ {exp.amount}
//               </p>
//             </div>

//             <div className="grid grid-cols-2 gap-3 text-sm">
//               <div>
//                 <p className="text-white/60 text-xs">Purpose</p>
//                 <p>{exp.purpose || "-"}</p>
//               </div>

//               <div>
//                 <p className="text-white/60 text-xs">Date</p>
//                 <p>
          

// {formatDate(exp.purchase_date)}

//                 </p>
//               </div>

//               <div>
//                 <p className="text-white/60 text-xs">
//                   Created By
//                 </p>
//                 <p>{exp.created_by_name}</p>
//               </div>

//               <div>
//                 <p className="text-white/60 text-xs">Bill</p>
//                 {exp.bill_path ? (
//                   <a
//                     href={`${FILE_BASE_URL}${exp.bill_path}`}
//                     target="_blank"
//                     className="text-blue-300 underline"
//                   >
//                     View Bill
//                   </a>
//                 ) : (
//                   "-"
//                 )}
//               </div>
//             </div>
// <div className="flex gap-3 mt-4">
//   <button
//     onClick={() => setEditExpense(exp)}
//     className="flex-1 py-2 rounded-lg bg-blue-500/20 text-blue-300"
//   >
//     Edit
//   </button>

//   <button
//     onClick={() =>
//       setDeleteModal({ show: true, id: exp.id })
//     }
//     className="flex-1 py-2 rounded-lg bg-red-500/20 text-red-300"
//   >
//     Delete
//   </button>
// </div>

//           </div>
//         ))}
//       </div>

//       {/* DELETE MODAL */}
// {deleteModal.show &&
//   createPortal(
//     <>
//       {/* Overlay */}
//       <div
//         className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9999]"
//         onClick={() => setDeleteModal({ show: false })}
//       />

//       {/* Modal */}
//       <div className="fixed inset-0 z-[10000] flex justify-center items-center px-4">
//         <div
//           className="
//             w-full max-w-sm
//             bg-white/10 backdrop-blur-xl
//             border border-red-400/30
//             rounded-2xl
//             shadow-2xl
//             text-white
//             overflow-hidden
//           "
//         >
//           {/* Header */}
//           <div className="px-6 py-4 bg-gradient-to-r from-red-700 to-red-600">
//             <h3 className="text-lg font-semibold">
//               Confirm Delete
//             </h3>
//           </div>

//           {/* Body */}
//           <div className="p-6 text-center">
//             <p className="mb-6 text-white/80">
//               Delete this expense?
//             </p>

//             <div className="flex gap-4 justify-center">
//               <button
//                 onClick={() =>
//                   setDeleteModal({ show: false })
//                 }
//                 className="px-5 py-2 rounded-lg bg-white/10"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={handleDeleteExpense}
//                 className="px-5 py-2 rounded-lg bg-red-600 hover:bg-red-500"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>,
//     document.body
//   )}

















// {editExpense && (
//   <EditExpenseModal
//     expense={editExpense}
//     categories={categories}
//     onClose={() => setEditExpense(null)}
//     onUpdated={() => {
//       setEditExpense(null);
//       loadExpenses();
//     }}
//   />
// )}

//     </div>
//   );
// }

// /* ------------------ UI helpers ------------------ */

// function Input(props) {
//   return (
//     <input
//       {...props}
//       className="bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500/40"
//     />
//   );
// }

// function Select({ options, placeholder, ...props }) {
//   return (
//     <select
//       {...props}
//       className="bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500/40"
//     >
//       <option value="">
//         {placeholder}
//       </option>
//       {options.map((o, i) => (
//         <option
//           key={i}
//           value={o.value}
//           className="text-black"
//         >
//           {o.label}
//         </option>
//       ))}
//     </select>
//   );
// }
